import { useQuery } from '@tanstack/react-query';
import { standardRequest } from 'shared/utils/request';
import { RejectModalOptionsResponse } from 'candidate_profile_redesign/shared/types';

export const useRejectionData = (rejectionModalPath: string) => {
  return useQuery<RejectModalOptionsResponse, Error>({
    queryKey: ['rejectionModalData', rejectionModalPath],
    queryFn: async () => {
      const response = await standardRequest.get(rejectionModalPath);
      return response.data;
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
};
